// extracted by mini-css-extract-plugin
export default {"search":"styles_search__xPTzv","search__wrapper":"styles_search__wrapper__XkZMf","search__overlay":"styles_search__overlay__Hl135"};